/*! systematica - built 2026-10-09T14:03:56.434Z */
;
/* js/custom.js */
$(function () {
	"use strict";
	var $body = $(
		".page-template-t-homepage, .page-template-t-about, .page-template-t-country",
	);
	if ($body.length === 0) {
		return;
	}

	// Reorder services on homepage
	var $servicesList = $(".services-list");
	if ($servicesList.length) {
		var serviceOrder = [
			"Strategic Planning & Advisory",
			"Integrated Mobility Planning",
			"Data-Driven Analysis & Traffic Modelling",
			"People Movement & Crowd Management",
			"Mobility Infrastructure Design",
		];
		var $serviceItems = $servicesList.children();
		var serviceMap = {};
		$serviceItems.each(function () {
			var name = $(this).find(".service-title").text().trim();
			serviceMap[name] = $(this);
		});
		$servicesList.empty();
		serviceOrder.forEach(function (orderName) {
			var normalizedName = orderName.toLowerCase();
			for (var key in serviceMap) {
				if (key.toLowerCase() === normalizedName) {
					$servicesList.append(serviceMap[key]);
					delete serviceMap[key];
					break;
				}
			}
		});
		// Append any remaining items
		for (var key in serviceMap) {
			$servicesList.append(serviceMap[key]);
		}
	}

	// Reorder industries on homepage
	var $industriesList = $(".industries-list");
	if ($industriesList.length) {
		var industryOrder = [
			"Urban & Regional Plans",
			"Large Developments & TOD",
			"Transport Infrastructure",
			"Complex Buildings",
			"Public Venues & Major Events",
		];
		var $industryItems = $industriesList.children();
		var industryMap = {};
		$industryItems.each(function () {
			var name = $(this).find(".industry-title").text().trim();
			industryMap[name] = $(this);
		});
		$industriesList.empty();
		industryOrder.forEach(function (orderName) {
			var normalizedName = orderName.toLowerCase();
			for (var key in industryMap) {
				if (key.toLowerCase() === normalizedName) {
					$industriesList.append(industryMap[key]);
					delete industryMap[key];
					break;
				}
			}
		});
		// Append any remaining items
		for (var key in industryMap) {
			$industriesList.append(industryMap[key]);
		}
	}

	var $highlighted = $(".page-template-t-homepage .highlighted-project-blocks");
	// Scope to homepage only: about/country news sliders are handled by _news-slider.js
	var $newsSlider = $(".page-template-t-homepage .news-slider-blocks");

	var highlightedSettings = {
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		variableWidth: true,
		centerMode: false,
		focusOnSelect: false,
		autoplay: false,
		infinite: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					variableWidth: true,
					centerMode: false,
					dots: false,
					arrows: true,
				},
			},
		],
	};

	var newsSettings = {
		slidesToShow: 2,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		variableWidth: false,
		centerMode: false,
		focusOnSelect: false,
		autoplay: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					variableWidth: true,
				},
			},
		],
	};

	function syncSlider($el, settings, breakpoint) {
		if (!$el.length) return;
		var bp = breakpoint || 1024;
		var isTabletOrBelow = $(window).width() <= bp;
		var isInitialized = $el.hasClass("slick-initialized");
		if (isTabletOrBelow && !isInitialized) {
			$el.slick(settings);
		} else if (!isTabletOrBelow && isInitialized) {
			$el.slick("unslick");
		}
	}

	function syncAll() {
		syncSlider($highlighted, highlightedSettings, 768);
		syncSlider($newsSlider, newsSettings);
	}

	syncAll();

	var resizeTimer;
	$(window).on("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(syncAll, 200);
	});
});

$(function () {
	"use strict";
	var $body = $(".industries-template-default");
	if ($body.length === 0) {
		return;
	}

	var $sameTaxProjects = $(".real-projects-list");
	$sameTaxProjects.slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: false,
		focusOnSelect: true,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					autoplaySpeed: 3000,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});
});

$(function () {
	"use strict";

	$(".industry-title").each(function () {
		$(this).html(
			$(this)
				.html()
				.replace("Data", '<span class="industriesKeyword">Data</span>'),
		);
		$(this).html(
			$(this)
				.html()
				.replace(
					"Infrastructure",
					'<span class="industriesKeyword">Infrastructure</span>',
				),
		);
		$(this).html(
			$(this)
				.html()
				.replace(
					"Master Planning",
					'<span class="industriesKeyword">Master Planning</span>',
				),
		);
		$(this).html(
			$(this)
				.html()
				.replace("Buildings", '<span class="industriesKeyword">Buildings</span>'),
		);
		$(this).html(
			$(this)
				.html()
				.replace("Events", '<span class="industriesKeyword">Events</span>'),
		);
		$(this).html(
			$(this)
				.html()
				.replace("Data", '<span class="industriesKeyword">Data</span>'),
		);
	});
});

// Header scroll behavior: add/remove scrolled class when past hero section
$(function () {
	"use strict";

	// Only on homepage
	if (!$("body").hasClass("page-template-t-homepage")) {
		return;
	}

	var $body = $("body");
	var heroHeight = $(window).height(); // Hero is typically 100vh

	function handleHeaderScroll() {
		var scrollTop = $(window).scrollTop();
		if (scrollTop > heroHeight - 80) {
			// 80px is header height
			$body.addClass("scrolled");
		} else {
			$body.removeClass("scrolled");
		}
	}

	// Check on scroll
	$(window).on("scroll", handleHeaderScroll);

	// Check on load
	handleHeaderScroll();
});

// Emergency: Projects filter desktop dropdown toggle
$(document).on("click", ".filter-dropdown-toggle", function (e) {
	console.log("Filter toggle clicked from custom.js", e);
	e.stopPropagation();
	var $menu = $(this).siblings(".filter-dropdown-menu");
	var isOpen = $menu.hasClass("open");
	$(".filter-dropdown-menu").removeClass("open");
	if (!isOpen) $menu.addClass("open");
});

$(document).on("click", function (e) {
	if (!$(e.target).closest(".filter-dropdown").length) {
		$(".filter-dropdown-menu").removeClass("open");
	}
});

$(function () {
	"use strict";

	if ($(".single-project").length === 0) return;

	var $list = $(".related-projects-list");
	if (!$list.length) return;

	var relatedSettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		variableWidth: false,
		centerMode: false,
		focusOnSelect: false,
		autoplay: false,
		infinite: true,
	};

	function syncRelatedProjects() {
		var isTabletOrBelow = $(window).width() <= 1024;
		var isInitialized = $list.hasClass("slick-initialized");

		if (isTabletOrBelow && !isInitialized) {
			$list.slick(relatedSettings);
		} else if (!isTabletOrBelow && isInitialized) {
			$list.slick("unslick");
		}
	}

	syncRelatedProjects();

	var resizeTimer;
	$(window).on("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(syncRelatedProjects, 200);
	});
});

